import React from 'react';

import { observer } from 'mobx-react';
import { Button, Paper } from '@mui/material';
import InfoRoundedIcon from '@mui/icons-material/InfoRounded';

import classes from './ScoringRuleRow.module.scss';
import { SCORING_RULE_DESCRIPTION } from './ScoringRuleRow.settings';
import { ScoringRuleModal } from './ScoringRuleModal/ScoringRuleModal';
import { useModalToggle } from '../../../../../shared/hooks/useModalToggle';
import { leaderboardStore } from '../../../../stores/leaderboardStore';

const ScoringRuleRow = observer(() => {
  const { challengeInfo } = leaderboardStore;

  const { scoringRules } = challengeInfo || {};

  if (!scoringRules) {
    return null;
  }

  const [isScoringRuleModalOpen, toggleScoringRuleModal] = useModalToggle(false);

  return (
    <>
      <Paper className={classes.scoringRuleRow} variant="roundedBox">
        {SCORING_RULE_DESCRIPTION[scoringRules] ? (
          <div className={classes.descriptionRow}>
            <InfoRoundedIcon color="info" />
            {SCORING_RULE_DESCRIPTION[scoringRules]}
          </div>
        ) : (
          <div />
        )}
        <Button
          className={classes.scoringRuleButton}
          variant="contained"
          size="small"
          onClick={toggleScoringRuleModal}
        >
          Open Scoring & Ranking Rules
        </Button>
      </Paper>
      <ScoringRuleModal
        open={isScoringRuleModalOpen}
        scoringRuleType={scoringRules}
        onClose={toggleScoringRuleModal}
      />
    </>
  );
});

export { ScoringRuleRow };
